import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router";
import { Nav, NavDropdown } from "react-bootstrap";
import { Permission } from "../../types/permission";
import { hasPermission } from "../../helpers/hasPermission";

const ROUTES = {
  MISSING: "/missing",
  MONTH_SUMMARY: "/monthSummary",
  MONTH_DETAIL: "/monthDetail",
  MONTH_STATISTICS: "/monthStatistics",
  CONG_AVG: "/congAvg",
  GROUP_AVG: "/groupAvg",
  PUB_AVG: "/pubAvg",
  RP_SUMMARY: "/rpSummary",
  AP_SUMMARY: "/apSummary",
  CONG_ANALYSIS: "/congAnalysis",
  SVC_YEAR_TOTALS: "/svcYearTotals",
  CO_REPORTS: "/coReports",
} as const;

export function NavReports() {
  const { t } = useTranslation();
  const location = useLocation();

  const getItemClass = (path: string) =>
    location.pathname === path ? "bg-primary text-white" : "";

  const showPioneersDivider =
    hasPermission(Permission.ViewSummaryRegpio) || hasPermission(Permission.ViewSummaryDetails);

  return (
    <Nav className="flex-column hg-nav">
      <NavDropdown.Item as={Link} to={ROUTES.MISSING} className={getItemClass(ROUTES.MISSING)}>
        {t("chart.legend.missing")}
      </NavDropdown.Item>

      <NavDropdown.Divider />
      <NavDropdown.Header>{t("nav.reports.monthly.0")}</NavDropdown.Header>

      <NavDropdown.Item as={Link} to={ROUTES.MONTH_SUMMARY} className={getItemClass(ROUTES.MONTH_SUMMARY)}>
        {t("nav.reports.monthly.summary")}
      </NavDropdown.Item>

      {(hasPermission(Permission.ViewSummaryDetails) || hasPermission(Permission.ViewSummaryDetailsGroup)) && (
        <NavDropdown.Item as={Link} to={ROUTES.MONTH_DETAIL} className={getItemClass(ROUTES.MONTH_DETAIL)}>
          {t("nav.reports.monthly.detail")}
        </NavDropdown.Item>
      )}

      <NavDropdown.Item as={Link} to={ROUTES.MONTH_STATISTICS} className={getItemClass(ROUTES.MONTH_STATISTICS)}>
        {t("nav.reports.monthly.statistics")}
      </NavDropdown.Item>

      <NavDropdown.Divider />
      <NavDropdown.Header>{t("nav.reports.averages.0")}</NavDropdown.Header>

      <NavDropdown.Item as={Link} to={ROUTES.CONG_AVG} className={getItemClass(ROUTES.CONG_AVG)}>
        {t("list.congregation.title")}
      </NavDropdown.Item>

      {(hasPermission(Permission.ViewSummaryDetails) || hasPermission(Permission.ViewSummaryDetailsGroup)) && (
        <NavDropdown.Item as={Link} to={ROUTES.GROUP_AVG} className={getItemClass(ROUTES.GROUP_AVG)}>
          {t("nav.reports.averages.group")}
        </NavDropdown.Item>
      )}

      {hasPermission(Permission.ViewReportsAll) && (
        <NavDropdown.Item as={Link} to={ROUTES.PUB_AVG} className={getItemClass(ROUTES.PUB_AVG)}>
          {t("list.publishers.title")}
        </NavDropdown.Item>
      )}

      {showPioneersDivider && <NavDropdown.Divider />}

      {hasPermission(Permission.ViewSummaryRegpio) && (
        <NavDropdown.Item as={Link} to={ROUTES.RP_SUMMARY} className={getItemClass(ROUTES.RP_SUMMARY)}>
          {t("recordcard.svcyeartotals.regular-pioneers")}
        </NavDropdown.Item>
      )}

      {hasPermission(Permission.ViewSummaryDetails) && (
        <NavDropdown.Item as={Link} to={ROUTES.AP_SUMMARY} className={getItemClass(ROUTES.AP_SUMMARY)}>
          {t("recordcard.svcyeartotals.auxiliary-pioneers")}
        </NavDropdown.Item>
      )}

      <NavDropdown.Divider />

      <NavDropdown.Item as={Link} to={ROUTES.CONG_ANALYSIS} className={getItemClass(ROUTES.CONG_ANALYSIS)}>
        {t("nav.reports.cong-analysis")}
      </NavDropdown.Item>

      <NavDropdown.Item as={Link} to={ROUTES.SVC_YEAR_TOTALS} className={getItemClass(ROUTES.SVC_YEAR_TOTALS)}>
        {t("nav.reports.svcyeartotals")}
      </NavDropdown.Item>

      {hasPermission(Permission.ViewReportsAll) && hasPermission(Permission.ViewUsers) && (
        <NavDropdown.Item as={Link} to={ROUTES.CO_REPORTS} className={getItemClass(ROUTES.CO_REPORTS)}>
          {t("general.circuit-overseer")}
        </NavDropdown.Item>
      )}
    </Nav>
  );
}
